import React, { useEffect, useState } from 'react';
import { Button, Checkbox, Col, Form, Input, Row, Select, Tabs, message } from 'antd';
import { FloatingLabel } from 'flowbite-react';
import { FaSave } from "react-icons/fa";
import Axois from '../utils/axios';
import { Link, useLoaderData, useLocation, useNavigate, useOutletContext, useParams } from 'react-router-dom';
import useAccountAPI from '../apis/accountAPI';
import EventEmitter from '../utils/eventEmitter';




const AddAccount = () => {
  const {account, accountTypes, taxes, tags} = useLoaderData();
  const [form] = Form.useForm();
  const [accountInfo, setAccountInfo] = useState(account.code ? {code: account.code, name: account.name} : {code: '', name: ''});
  const { success, error } = useOutletContext();
  const paramName = useParams();  
  const { create, update } = useAccountAPI();  
  const navigate = useNavigate();

  const onChangeCode = e => setAccountInfo({...accountInfo, code: e.target.value});
  const onChangeName = e => setAccountInfo({...accountInfo, name: e.target.value});

  

  const submitAccountInfo = async() => {
    let data = form.getFieldsValue();
    data['code'] = accountInfo.code;
    data['name'] = accountInfo.name;
    create(data, success);
  }

  const updateAccount = () => {
    let data = form.getFieldsValue();
    data['code'] = accountInfo.code;
    data['name'] = accountInfo.name;
    update(account.code, data, success); 
    console.log(data)
  }

  useEffect(() => {
    EventEmitter.subscribe('account_created', data => {
      navigate('/accounting/accounts/'+data);
    })

    return () => {
      EventEmitter.unsubscribe('account_created');
    }
  },[])


  return (
    <div className='container mx-auto' style={{maxWidth: '900px'}}>
      <div className='flex justify-between'>
        <div>
        <h3>
          <Link to='/accounting/accounts' className='font-normal'>
            <span className='whitespace-nowrap hover:underline font-medium text-sky-600 dark:text-white'>
              Charts of Account
            </span>
          </Link>{' '}
          / {paramName.action}
        </h3>
        </div>
        <Button onClick={paramName.action !== 'new' ? updateAccount: submitAccountInfo} htmlType='button' icon={<FaSave />}>{paramName.action !== 'new' ? 'Update' : 'Save'}</Button>
      </div>
      <div className='mt-5 bg-white'>
        <Form 
          form={form}
          className='shadow p-3' 
          labelAlign='left'
          labelCol={{ span: 8, }}
          initialValues={account.code ? account : {allow_reconciliation: false, deprecated: false }} 
          variant='borderless'
        >
            <FloatingLabel className='text-2xl' variant="standard" label="Code" name='code' value={accountInfo.code} onChange={onChangeCode}/>
            <FloatingLabel className='text-2xl' variant="standard" label="Account Name" name='name' value={accountInfo.name} onChange={onChangeName }/>

          <Tabs
            type="card"
            items={[
              {
                key: '1',
                label: 'Accounting',
                children: 
                  <Row>
                    <Col md={{span: 11}}>
                      <Form.Item label='Type' name={'type_id'} className='font-bold mb-1'>
                        <Select options={accountTypes.map(type => ({ label: <span key={type._id}>{type.parent}</span>, title: type.parent, options:type.children.map(account =>({label: <span key={account.type}>{account.type}</span>, value: account.id}) )}))} className='border-x-0 border-t-0' />
                      </Form.Item>
                      <Form.Item label='Default Taxes' name={'default_tax_ids'} className='font-bold mb-1'>
                        <Select mode='tags' options={taxes.map(tax => ({value: tax._id, label: tax.name}) )} className='border-x-0 border-t-0' />
                      </Form.Item>
                      <Form.Item label='Tags' name={'tag_ids'} className='font-bold mb-1'>
                        <Select mode='tags' options={tags.map(tag => ({value: tag._id, label: tag.name}) )} className='border-x-0 border-t-0' />
                      </Form.Item>
                    </Col>
                    <Col md={{span: 11, offset: 1}}>
                      <Form.Item labelCol={{sm: { span: 10}}} label='Allow Reconciliation' name={'allow_reconciliation'} className='font-bold mb-1' valuePropName='checked'>
                        <Checkbox />
                      </Form.Item>
                      <Form.Item labelCol={{sm: { span: 10}}} label='Deprecated' name={'deprecated'} className='font-bold mb-1' valuePropName='checked'>
                        <Checkbox />
                      </Form.Item>
                    </Col>
                  </Row>
              },
            ]}
          />
        </Form>
      </div>
    </div>
  )
}
export default AddAccount;